var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsDownloadButton001',{attrs:{"file-name":"fileName"}},[_c('WsButton001',{attrs:{"out-line":""}},[_vm._v(" 下載 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }